import React from "react";
import { MdErrorOutline } from "react-icons/md";

const FieldError = ({ error }) => (
  <div id="error" className="mt10">
    <MdErrorOutline className="error-icon" />
    {error}
  </div>
);

export default FieldError;
